import script from "./DemandData.vue?vue&type=script&setup=true&lang=js"
export * from "./DemandData.vue?vue&type=script&setup=true&lang=js"

import "./DemandData.vue?vue&type=style&index=0&id=4a3afd34&lang=scss"

const __exports__ = script;

export default __exports__